import { c as _c } from "react/compiler-runtime";
import { ThemedLogoFpMark } from '@onefootprint/icons';
import { LinkButton, useConfirmationDialog } from '@onefootprint/ui';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
type WalkthroughHeaderProps = {
  /** The running walkthrough's title; none once it ends, which plays the pill out. */
  title?: string;
  onEnd: () => void;
};

// A pill rather than a full-width band, so it reads as Percy being with you, not a system banner. The
// chat's own title already names the walkthrough. It floats in the message list's top padding instead
// of taking a row, so the conversation sits where it does in any chat and never shifts as it comes and
// goes. A fade behind it keeps a scrolled conversation from showing through around it. Enters only
// when a walkthrough starts mid-chat.
const WalkthroughHeader = t0 => {
  const $ = _c(9);
  const {
    title,
    onEnd
  } = t0;
  const reduceMotion = useReducedMotion();
  const confirmation = useConfirmationDialog();
  let t1;
  if ($[0] !== confirmation || $[1] !== onEnd) {
    t1 = () => confirmation.open({
      title: "End this walkthrough?",
      description: "You can start it again later, but Percy won't pick up where you left off.",
      variant: "destructive",
      primaryButton: {
        label: "End walkthrough",
        onClick: onEnd
      },
      secondaryButton: {
        label: "Keep going"
      }
    });
    $[0] = confirmation;
    $[1] = onEnd;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const confirmEnd = t1;
  let t2;
  if ($[3] !== confirmEnd || $[4] !== reduceMotion || $[5] !== title) {
    t2 = title && <motion.section key="walkthrough-header" aria-label="Active walkthrough" className="pointer-events-none absolute inset-x-0 top-0 z-20 flex justify-center bg-gradient-to-b from-primary via-primary to-transparent px-4 pt-4 pb-6" initial={reduceMotion ? false : {
      opacity: 0,
      y: -5
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0,
      transition: {
        duration: 0
      }
    } : {
      opacity: 0,
      y: -5
    }} transition={{
      duration: 0.3,
      ease: "easeOut"
    }}><div className="pointer-events-auto flex items-center whitespace-nowrap gap-2.5 rounded-full border border-tertiary bg-primary py-1.5 pr-3.5 pl-1.5 shadow-[var(--elevation-1)]"><span className="flex size-6 shrink-0 items-center justify-center rounded-full border border-tertiary bg-primary"><ThemedLogoFpMark className="size-3" color="primary" aria-hidden={true} /></span><span className="text-label-3 text-primary">Walkthrough with Percy</span><span className="h-4 border-l border-tertiary" aria-hidden={true} /><LinkButton variant="label-3" onClick={confirmEnd}>End walkthrough</LinkButton></div></motion.section>;
    $[3] = confirmEnd;
    $[4] = reduceMotion;
    $[5] = title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <AnimatePresence initial={false}>{t2}</AnimatePresence>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default WalkthroughHeader;